export type ContentCurrency = "USD" | "MXN" | "COP";

export const contentCurrencyFromCountry = (
  isoAlpha3?: string | null,
  name?: string | null
): ContentCurrency => {
  const iso = (isoAlpha3 ?? "").trim().toUpperCase();
  const country = (name ?? "").trim().toUpperCase();
  if (iso === "COL" || iso === "CO" || country === "COLOMBIA") return "COP";
  if (iso === "MEX" || iso === "MX") return "MXN";
  if (country === "MEXICO" || country === "MÉXICO") return "MXN";
  return "USD";
};
